var _rect, _line, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    x2: 208,
    y1: 40.001,
    y2: 216.001,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    d: "M154.9071 157.599a40.00028 40.00028 0 0 1-53.8142-59.19562M73.99446 68.59479C33.22519 89.24034 16 128.00122 16 128.00122s32 71.99219 112 71.99219a118.0238 118.0238 0 0 0 53.99756-12.59461M208.60953 169.10059C230.41132 149.57342 240 128.00122 240 128.00122S208 55.99341 128 55.99341a125.31923 125.31923 0 0 0-20.68221 1.68414M135.52737 88.709a40.02411 40.02411 0 0 1 32.29785 35.52874"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.14e12bdec7764aabdc4ef45ef4b42bbd.svg";
export { ForwardRef as ReactComponent };